import React from 'react';
import { injectIntl } from 'react-intl';
import TransitionLink from 'components/transition-link/transition-link';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import Logo from 'components/logos/logo';
import NavLinks from 'components/nav/nav-links';
import NavUserDropdown from 'components/nav/nav-user-dropdown';
import NavDrawer from 'components/nav/nav-drawer';
import NavHamburger from 'components/nav/nav-hamburger';
import SkipLink from 'components/nav/skip-link';
import messages from './messages';

class Nav extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      'isOpen': false
    };

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.toggleNavMenu = this.toggleNavMenu.bind(this);
    this.onLogoutClick = this.handleLogoutClick.bind(this);
    this.onNavLinkClick = this.handleNavLinkClick.bind(this);
  }

  /**
   * React Lifecycle Hook
   * Invoked once, immediately before mounting occurs. It is called before
   * render(), therefore setting state synchronously in this method will not
   * trigger a re-rendering.
   *
   * @method  componentWillMount
   */
  componentWillMount() {
    const { intl } = this.props;

    this.sessionLinks = {
      'authenticated': [
        {
          'description': intl.formatMessage(messages.account_profiles_link_label),
          'path': '/profile'
        },
        {
          'description': intl.formatMessage(messages.logout_link_label),
          'action': this.onLogoutClick
        }
      ],
      'public': [
        {
          'description': 'Sign In',
          'path': '/sign-in'
        },
        {
          'description': 'Create Account',
          'path': '/create-account'
        }
      ]
    };
  }

  /**
   * Toggles visibility of nav based on
   * previous isOpen states
   *
   * @method  toggleNavMenu
   */
  toggleNavMenu() {
    this.props.handleNavOpen(!this.state.isOpen);
    this.setState({ 'isOpen': !this.state.isOpen});
  }

  /**
   * Sends user to authService to logout
   *
   * @method  handleLogoutClick
   */
  handleLogoutClick() {
    this.props.authService.removeToken();

    this.props.setAuthState(false, () => {
      this.props.history.replace('/');
      if (this.state.isOpen) {
        this.toggleNavMenu();
      }
    });
  }

  handleNavLinkClick() {
    this.toggleNavMenu();
  }

  render() {
    const { intl } = this.props;

    const sessionLinks = this.props.authenticated ? this.sessionLinks.authenticated : this.sessionLinks.public;
    const navCenterClasses = classNames(
      'nav-center',
      {
        'nav-center_hidden': !this.props.authenticated
      }
    );
    const navRightClasses = classNames(
      'nav-right',
      {
        'nav-right_hidden': !this.props.authenticated
      }
    );

    return (
      <nav className="nav" role="navigation">
        <div className="nav-inner">
          <SkipLink />
          <TransitionLink to="/" className="nav-logo">
            <span className="isVisuallyHidden">{intl.formatMessage(messages.home_page_link_label)}</span>
            <Logo logoType="nav" />
          </TransitionLink>
          <div className={navCenterClasses}>
            <NavLinks isVisible={this.props.authenticated} />
          </div>
          <div className={navRightClasses}>
            <NavUserDropdown
              user={this.props.user}
              onLogout={this.onLogout}
              sessionLinks={sessionLinks}
            />
          </div>
          <NavHamburger isVisible={this.props.authenticated} onClick={this.toggleNavMenu} />
          <NavDrawer
            isOpen={this.state.isOpen}
            toggleNavMenu={this.toggleNavMenu}
            authenticated={this.props.authenticated}
            onLogout={this.onLogout}
            onNavLinkClick={this.onNavLinkClick}
            sessionLinks={sessionLinks}
          />
        </div>
      </nav>
    );
  }
}

const NavWithRouter = withRouter(injectIntl(Nav));
export default NavWithRouter;



// WEBPACK FOOTER //
// ./src/client/components/nav/nav.jsx